import { createGlobalStyle } from "styled-components";

const GlobalTheme = createGlobalStyle`
  body {
    font-size: ${props => props.theme.text.default};
    font-family: ${props => props.theme.font};
    color: ${props => props.theme.color["Primary Text"]};
  }

  .fa-ease-in-out-spin{
    -webkit-animation: fa-spin 2s infinite ease-in-out;
    animation: fa-spin 2s infinite ease-in-out;
  }

  .alertLabel{
    font-weight: 600; 
    font-size: 18px;
  }

  .alertDescription{
    font-size: 18px;
  }

  .alertIcon{
    padding-top: 3px;
  }

  .alertIconSize{
    font-size: 20px;
  }

  .tabletAlertIcon{
    display: flex;
    padding-top: 4px;
  }

  .closeIcon{
    font-size: 12px;
    margin-top: 9px;
    flex-shrink: 0;
  }

  .mobileMessage{
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .mobileAlertIcon{
    font-size: 20px;
    color: #faad14;
    margin-top: 4px;
    flex-shrink: 0;
  }

  .mobileLabel{
    font-weight: 600;
    font-size: 18px;
  }

  .viewMore{
    font-size: 18px;
    cursor: pointer;
    width: fit-content;
    padding-left: 33px;
  }

  .viewMoreSize{
    font-size: 12px;
  }

  .mobileDescription{
    padding-left: 33px;
  }

  .descriptionFont{
    font-size: 18px;
  }

  .viewLess{
    padding: 8px 0 0 0;
    font-size: 18px;
    background: none;
    border: none;
    cursor: pointer;
  }

  .viewLessSize{
    font-size: 12px;
  }

  .text-capitalize {
    text-transform: capitalize;
  }

  .text-capitalize-first::first-letter {
    text-transform:capitalize;
  }

  .textUpperCase {
    text-transform: uppercase;
  }

  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: transparent !important;
    border-right: 3px solid #fff;
  }
  
  .ant-btn.disabled, .ant-btn[disabled] {
    cursor: default !important;
  }
  .ant-dropdown-menu-item-disabled, .ant-dropdown-menu-submenu-title-disabled, .ant-dropdown-menu-item-disabled:hover, .ant-dropdown-menu-submenu-title-disabled:hover {
    cursor: default !important;
  }

  ant-checkbox-disabled + span, .ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {
    cursor: default !important;
  }

  .center-text {
    text-align: center;
  }

  .right {
    text-align:right;
  }
  
  .textUpperCase {
    text-transform: uppercase;
  }

  .text-color-error {
    color: ${props => props.theme.color["Error Primary"]};
  }

  .textColorSuccess {
    color: ${props => props.theme.color["Success Primary"]};
  }

  .textSemibold {
    font-weight: ${({ theme }) => theme.text.semibold};
  }

  .textBold {
    font-weight: ${props => props.theme.text.bold} !important;
  }

  .ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ellipsisNoWidth {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .header1 {
    color: ${props => props.theme.color.grey["grey-10"]};
    font-size: ${props => props.theme.text.f20};
    font-weight: ${props => props.theme.text.regular};
    text-transform: capitalize;
  }

  .header2 {              
    color: ${props => props.theme.color["Primary text"]};
    font-size: ${props => props.theme.text.f18};
    font-weight: ${props => props.theme.text.bold};
    text-transform: capitalize;
  }

  .fieldLabel {
    color: ${props => props.theme.color["Primary text"]};
    font-size: ${props => props.theme.text.f14};
    font-weight: ${props => props.theme.text.regular};
  }

  .fieldValue {
    color: ${props => props.theme.color["Primary text"]};
    font-size: ${props => props.theme.text.f14};
    font-weight: ${props => props.theme.text.semibold};
  }

  .fieldValueLight {
    color: ${props => props.theme.color["Secondary text"]};
    font-size: ${props => props.theme.text.f14};
    font-weight: ${props => props.theme.text.regular};
  }

  .fieldSubValueLight {
    color: ${props => props.theme.color["Secondary text"]};
    font-size: ${props => props.theme.text.f12};
    font-weight: ${props => props.theme.text.regular};
  }

  .descriptionTextLarge{
    color: ${props => props.theme.color["Primary text"]};
    font-size: ${props => props.theme.text.f16};
    font-weight: ${props => props.theme.text.regular};
  }

  .marginSmallBottom {
    margin-bottom:0.5em;
  }

  .marginSmallBottomMinus{
    margin-bottom:-0.5em;
  }

  .marginSmallTop{
    margin-top:0.5em;
  }

  .marginSmallTopMinus{
    margin-top:-0.5em;
  }

  @media print {
    @page {
      margin: .5in;
    }
  
    .ant-layout-footer,
    .ant-layout {
      background-color: transparent !important;
    }
  
    body {
      font-size: 8pt !important;
    }
  
    .ant-layout {
      height: auto !important;
    }
  
    .isomorphicSidebar {
      flex: 0 0 0;
      max-width: 0;
      min-width: 0;
      width: 0;
      display: none !important;
    }
  
    .isomorphicTopbar,
    .ant-back-top {
      display: none !important;
    }
  
    .isoContentMainLayout {
      position: relative !important;
      width: auto !important;
      height: auto !important;
      overflow: visible !important;
      transform: scale(1);
      transform-origin: top left;
    }

    .ant-back-top {
      right: 40px !important;
    }

    .fefDashboard {
      padding: 0;
    }
  }

  .smoothScrollbarFillParent {
    & > section,
    & > section > .scroll-content,
    & > section > .scroll-content > div{
      height: 100%;

    }
  }

  .antSpinFillParent {
    & > .ant-spin-nested-loading,
    & > .ant-spin-nested-loading > .ant-spin-container {
      height: 100%;
    }
  }

  .editUserAvatarTooltip {
    .ant-tooltip-content {
      margin-left: 35px;
      .ant-tooltip-arrow {
        margin-left: 35px;
      }
    }
  }

  .userAvatarTooltip {
    .ant-tooltip-content {
      margin-left: 17px;
      .ant-tooltip-arrow {
        margin-left: 17px;
      }
    }
  }

  .settingsPopconfirm {
    white-space: pre-line;
    padding-top: 70px;
    padding-left: 14px;
    .ant-popover-content{
      .ant-popover-arrow{
        margin-top: 60px;
        margin-left: 14px;
      }
      .ant-popover-inner{
        .ant-popover-inner-content{
          .ant-popover-message{
            padding-bottom: 0;
            .ant-popover-message-title{
              p {
                margin-bottom: 0.9em;
              }
            }
          }
        }
      }
    }
  }
`;

export default GlobalTheme;
